import React, { useEffect, useState } from "react";
import Close from "./../assets/cancel.svg";
import Download from "./../assets/white-download.svg";
import { ExcelRenderer } from "react-excel-renderer";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import { export_product_file } from "../actions/orders";

const Bulk = ({ setTable, setPreview }) => {
  const [file, setFile] = useState(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const stored_details = useSelector((state) => state?.orders?.storedOrder);
  const fileurl = useSelector(
    (state) => state?.orders?.export_product?.data?.url
  );
  const file_loading = useSelector(
    (state) => state?.orders?.export_product?.loading
  );
  const orderTypeMap = {
    "41": "ftl",
    "10": "fd",
    "43": "ltl",
    "44": "tyreset-4",
  };
  const order_type = orderTypeMap[stored_details?.vtweg] || "";
  const [fileError, setFileError] = useState("");

  useEffect(() => {
    dispatch(
      export_product_file({
        email: localStorage.getItem("email"),
        fd_origin_id: stored_details.fd_origin_id,
        order_type: order_type,
        vtweg: stored_details.vtweg,
      })
    );
    // eslint-disable-next-line
  }, []);
  return (
    <div className="m2 claim-card p1 pl2 bulk-order">
      <span className="close cursor">
        <img
          src={Close}
          alt="close"
          width={15}
          onClick={() => {
            history.push("/shop-for-tyres");
          }}
        />
      </span>
      <h3>Create Bulk Order - Select File</h3>
      <div className="d-flex">
        <div className="br-right pr2">
          <div className="d-flex mt2 sample-download">
            {fileurl ? (
              <a href={fileurl} download>
                Sample download file
              </a>
            ) : file_loading ? (
              <span>Updating File</span>
            ) : (
              <span>Sample File Failed to download</span>
            )}
            <span className="ml1">
              Note: Sample file are the plain template without the data
            </span>
          </div>
          <p>
            Download the sample template to view all the product information.
            Enter the quantities and upload back the file to add items to the
            cart.
          </p>
          <div className="mt2">
            <label className="label">
              Upload file <sup>*</sup>
            </label>
            <div className="upload-input">
              <input className="pl1" value={file?.name} readOnly={true} />
              <input
                id="file"
                type={"file"}
                className="pl1 d-none"
                onChange={(event) => {
                  let fileObj = event.target.files[0];
                  if (fileObj) {
                    setFile(fileObj);
                    setFileError("");
                    //just pass the fileObj as parameter
                    ExcelRenderer(fileObj, (err, resp) => {
                      if (err) {
                        console.log(err);
                      } else {
                        const headerRow = resp?.rows?.[0] || [];
                        // find column indexes dynamically
                        const ipCodeIdx = headerRow.indexOf("IP Code");
                        const oepregion = headerRow.indexOf("Origin");
                        const brandIdx = headerRow.indexOf("Brand");
                        const rimIdx = headerRow.indexOf("Rim");
                        const unitPriceIdx = headerRow.indexOf("Unit Price");
                        const qtyIdx = headerRow.indexOf("Order Qty");
                        const qpcIdx = headerRow.indexOf("QPC");
                        // build header cols (pick what you need)
                        let cols = [
                          headerRow[ipCodeIdx],
                          headerRow[oepregion],
                          headerRow[brandIdx],
                          headerRow[rimIdx],
                          headerRow[unitPriceIdx],
                          headerRow[qtyIdx],
                          headerRow[qpcIdx],
                        ].filter(Boolean);
                        resp.rows.splice(0, 1);
                        // build rows
                        let rows = resp.rows
                          ?.filter(
                            (ele) =>
                              ele.length > 0 &&
                              Number(ele?.[qtyIdx] || 0) > 0 
                          )
                          ?.map((ele) => [
                            ele[ipCodeIdx],
                            ele[oepregion],
                            ele[brandIdx],
                            ele[rimIdx],
                            parseFloat(ele[unitPriceIdx]).toFixed(2),
                            ele[qtyIdx],
                            ele[qpcIdx],
                          ]);
                        setTable({
                          cols,
                          rows,
                        });
                      }
                    });
                  }
                }}
              />
              <button
                onClick={() => {
                  // document.getElementById("file").value = null
                  document.getElementById("file").click();
                }}
              >
                <img src={Download} alt="download" width={12} className="mr1" />
                Choose file
              </button>
            </div>
            <span className="ml1 dim-note">
              Maximum File Size: 5 MB | File Format: CSV or XLS
            </span>
            {fileError && (
              <div className="error-text mt1">{fileError}</div>
            )}
          </div>
          <div className="mt3">
            <button className="cancel-btn mr2">Cancel</button>
            <button
              className="primary-btn"
              onClick={() => {
                if (!file) {
                  setFileError("Upload file is required");
                  return;
                }
                setFileError("");
                setPreview(true);
              }}
            >
              Upload
            </button>
          </div>
        </div>
        <div className="m2 page-tips">
          <h3>Page tips</h3>
          <ul>
            <li>
              - Download the sample file by clicking on Sample File Button
            </li>
            <li>- Enter the order required details on the file.</li>
            <li>- Upload the same file format.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Bulk;
